// src/pages/AiPlatform/styles.js — só o que o tema e o kit do painel não cobrem
import { makeStyles } from "@material-ui/core/styles";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  const dark = t.mode === "dark";
  return {
    scroll: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      paddingBottom: 16,
      ...theme.scrollbarStyles,
    },
    // Section tem altura própria: sem isto o flex da coluna a espreme
    block: { flex: "none" },
    lead: {
      margin: "-6px 0 16px",
      fontSize: 13,
      lineHeight: 1.5,
      color: t.textSecondary,
      maxWidth: 720,
    },
    formFooter: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 16,
    },
    adornIcon: { fontSize: 18, color: t.textMuted },
    tableScroll: {
      overflowX: "auto",
      ...theme.scrollbarStyles,
      "& .MuiTableCell-root": { whiteSpace: "nowrap" },
      "& .MuiTableRow-root:last-child > .MuiTableCell-body": { borderBottom: 0 },
    },
    cellField: {
      width: 112,
      "& .MuiOutlinedInput-input": { padding: "7px 10px", textAlign: "right", fontSize: 13 },
    },
    kpis: {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gap: 12,
      padding: "16px 20px",
      borderBottom: `1px solid ${t.line}`,
      [theme.breakpoints.down("xs")]: { gridTemplateColumns: "minmax(0, 1fr)" },
    },
    positive: { color: dark ? t.status.ok.fg : t.semantic.success, fontWeight: 600 },
    negative: { color: dark ? t.status.down.fg : t.semantic.error, fontWeight: 600 },
    over: { color: dark ? t.status.warn.fg : t.semantic.warning, fontWeight: 600 },
    periodField: { width: 170 },
  };
});

export default useStyles;
